export var INPUT_SIZES = { xs: 224, sm: 320, md: 416, lg: 608 };
export var CELL_SIZE = 32;
export var DEFAULT_FILTER_SIZES = [
    3, 16, 32, 64, 128, 256, 512, 1024, 1024
];
//# sourceMappingURL=const.js.map